<template>
  <div class="chat-thread" ref="scroller">
    <ChatMessage v-for="msg in messages" :key="msg.id" :message="msg" />
    <div class="chat-thread__typing" v-if="isLoading">
      <span></span><span></span><span></span>
    </div>
  </div>
</template>

<script>
import ChatMessage from './ChatMessage.vue'

export default {
  name: 'ChatThread',
  components: { ChatMessage },
  computed: {
    messages () {
      return this.$store.state.chat.messages
    },
    isLoading () {
      return this.$store.state.chat.isLoading
    }
  },
  watch: {
    messages: { handler: 'scrollToBottom', deep: true },
    isLoading: 'scrollToBottom'
  },
  mounted () {
    this.scrollToBottom()
  },
  methods: {
    scrollToBottom () {
      this.$nextTick(() => {
        const el = this.$refs.scroller
        if (el) el.scrollTop = el.scrollHeight
      })
    }
  }
}
</script>

<style scoped>
.chat-thread {
  overflow-y: auto;
  padding: 16px;
}
.chat-thread__typing {
  display: inline-flex;
  gap: 5px;
  padding: 12px 16px;
  background: #F1F3F5;
  border-radius: 16px;
  border-bottom-left-radius: 4px;
}
.chat-thread__typing span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #98A0A6;
  animation: chat-bounce 1.2s infinite ease-in-out;
}
.chat-thread__typing span:nth-child(2) { animation-delay: 0.15s; }
.chat-thread__typing span:nth-child(3) { animation-delay: 0.3s; }

@keyframes chat-bounce {
  0%, 60%, 100% { transform: translateY(0); opacity: 0.5; }
  30% { transform: translateY(-5px); opacity: 1; }
}
</style>
